import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@elotech/angular-common';
import { FileService } from '../../../../folha-pagamento/src/common/services/file.service';

@Injectable()
export class PortalFileService extends FileService {

  private readonly resourcePortal: string = '/api/portal-servidor/arquivo';

  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  public getPresignedDownloadUrl(fileKey: string, secure: boolean): Observable<any> {
    return this.httpClient.get({
      resource: `${this.resourcePortal}/url-presigned?fileKey=${encodeURIComponent(fileKey)}&secure=${secure}`
    });
  }
}
